module.exports = __webpack_public_path__ + "r-v3/img/ml_42_00.0b1b1fbc.jpg";